import { useMutation } from "@tanstack/react-query";

export const mutateShowcaseIndex = (initParams = {}) => {

    const mutation = useMutation({
        mutationKey: ['mutate-showcase-index', initParams],
        mutationFn: async (params = {}) => {
            const res = await axios.get(route('studio.editor.api.showcases.index'), {
                params: {
                    ...initParams,
                    ...params
                }
            });
            return res;
        },
    });

    return mutation;
} 